import { render } from "./management.cattle.io.node.vue?vue&type=template&id=247cd4fe"
import script from "./management.cattle.io.node.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.node.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__